import { Navigate } from 'react-router-dom';
import { AppShell } from '../../components/layout/AppShell';
import { PlatformShell } from '../platform/PlatformShell';
import { useSession } from './useAuth';

/** Tenant users get the tenant portal; a platform account (null tenant) is
 * sent to the platform console (Architecture §5.3 — separate consoles). */
export function TenantOnly() {
  const session = useSession();
  if (session.tenant_id === null) return <Navigate to="/platform" replace />;
  return <AppShell />;
}

export function PlatformOnly() {
  const session = useSession();
  if (session.tenant_id !== null) return <Navigate to="/" replace />;
  return <PlatformShell />;
}
